export default __webpack_public_path__ + "static/media/abra-news.cb16f009.jpeg";